import * as Yup from 'yup';

export interface SeasonClawPrizeFormData {
  stockType: 'limited' | 'unlimited';
  active: boolean;
  clawMachinePrizeId: string;
  rewardValue: number;
  quantity?: number;
  probability: number;
  cheatCodePositions?: { x: number; z: number }[];
  cheatCodeProbability: number;
};

export const seasonClawPrizeSchema = Yup.object().shape({
  active: Yup.boolean().optional().default(false),
  stockType: Yup.string().oneOf(['limited', 'unlimited']).required("El tipo de stock es requerido"),
  clawMachinePrizeId: Yup.string().required("El premio es requerido"),
  rewardValue: Yup.number().min(0, "El valor del premio debe ser positivo").required("El valor del premio es requerido"),
  quantity: Yup.number().min(0, "La cantidad debe ser positiva").optional(),
  probability: Yup.number().min(0, "La probabilidad debe ser positiva").required("La probabilidad es requerida"),
  cheatCodePositions: Yup.array().of(Yup.object().shape({
    x: Yup.number().required("La coordenada X es requerida"),
    z: Yup.number().required("La coordenada Z es requerida"),
  })).optional(),
  cheatCodeProbability: Yup.number().min(0, "La probabilidad debe ser positiva").max(1, "La probabilidad no puede ser mayor a 1").default(0.0),
});